var _path, _path2, _path3, _ellipse, _path4, _path5, _circle, _circle2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle3, _circle4, _circle5, _circle6, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnstackExpertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 163,
    viewBox: "0 0 101 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15783 36.716C7.66668 25.3488 22.0513 24.3628 26.2948 24.2045L24.8803 31.8011C22.2252 31.0449 13.5041 30.0029 10.8469 36.716C5.53692 50.1312 19.5703 62.0466 35.5 57.1317L33.6037 63.1808C19.1911 68.0957 0.985657 55.6195 5.15783 36.716Z",
    fill: "#57455D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3687 61.3651C27.8041 56.6065 31.5211 52.4225 36.313 52.4225H61.1795C65.5977 52.4225 69.1795 56.0042 69.1795 60.4225V86.9925C69.1795 88.0326 69.9768 88.8917 71.004 89.0555C81.6088 90.7463 94.2115 99.4201 94.2115 109.313C94.2115 117.298 89.4861 122.656 83.7915 125.458C83.4806 125.611 83.2629 125.907 83.2209 126.251L81.6441 139.181C81.2648 142.292 78.986 144.835 75.936 145.553C70.8839 146.742 66.1876 142.546 66.8011 137.393L67.675 130.052C67.7479 129.44 67.2546 128.908 66.6385 128.935L55.2257 129.431C50.6753 129.629 46.8782 125.994 46.8782 121.439V121.283C46.8782 117.702 49.2571 114.558 52.7025 113.584L61.8266 111.006C62.9199 110.697 62.7302 109.136 61.5945 109.102C56.8362 108.961 52.5126 108.822 48.2827 108.209C38.5152 106.794 32.6613 97.5434 31.4984 87.7427L28.3687 61.3651Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1795 26.9353C69.1795 39.0006 62.7561 48.7814 50.559 48.7814C38.362 48.7814 24.577 41.9991 24.577 29.9338C24.577 17.8685 34.8977 5.08914 47.0948 5.08914C59.2918 5.08914 69.1795 14.87 69.1795 26.9353Z",
    fill: "#B4C7E7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.4552,
    ry: 13.0512,
    transform: "matrix(0.991066 -0.13337 0.131261 0.991348 48.2976 34.2761)",
    fill: "#C39A89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3302 26.4271C62.185 32.8429 57.1232 34.4788 48.8976 27.9478C45.0463 32.3897 40.3959 34.6046 35.7016 32.5806C35.9212 30.231 36.876 25.8205 37.5608 24.2991C39.7798 19.3691 43.5946 16.4078 48.5645 16.8723C54.3006 17.4084 58.8166 21.1918 60.3302 26.4271Z",
    fill: "#57455D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2631 23.439C36.6968 15.5554 32.3462 15.9159 27.2993 19.5321C27.0106 20.8615 38.0017 29.9189 42.2631 23.439Z",
    fill: "#57455D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.6505,
    cy: 36.2654,
    r: 2.04808,
    fill: "#57455D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.8429,
    cy: 35.3552,
    r: 2.04808,
    fill: "#57455D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5918 68.5136C45.5472 66.4276 47.1134 64.6578 49.1893 64.4483L60.4143 63.3156C62.7016 63.0848 64.7123 64.8249 64.8122 67.1217L65.3768 80.1091C65.4679 82.2041 63.9256 84.0138 61.8426 84.256L50.335 85.5941C47.9928 85.8665 45.9244 84.0639 45.8739 81.7064L45.5918 68.5136Z",
    fill: "#F7D06F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3539 66.8196C42.809 67.6459 44.972 70.2087 42.1238 70.3116C41.3539 72.9578 40.1594 73.5956 38.3993 72.0227C37.1501 70.9064 36.426 69.3619 37.2419 67.9251C38.0577 66.4883 39.8987 65.9933 41.3539 66.8196Z",
    fill: "#74A2D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7821 78.3497C42.7821 79.9119 42.764 80.0457 41.1844 80.4986C39.4275 81.0025 35.9373 80.1615 36.4638 78.0076C36.8375 76.4788 37.8782 75.1789 39.6229 75.1789C41.3677 75.1789 42.7821 76.7874 42.7821 78.3497Z",
    fill: "#74A2D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6408 68.7973C17.4899 62.9186 26.036 58.417 30.078 56.9011L33.0057 66.0683C32.9298 67.2269 31.8573 70.2305 28.1748 72.9753C26.6262 74.1297 25.7825 76.2014 25.3702 78.4842C24.6795 82.3085 20.804 85.4743 17.185 84.0582L15.9098 83.5593C13.4966 82.6151 12.2059 79.9856 12.956 77.5053C13.6867 75.089 14.6238 72.0307 15.6408 68.7973Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9871 52.2259L68.0622 66.9865C78.5297 57.5635 81.8281 40.5513 84.0419 33.0589C84.6908 30.8627 84.3294 28.4732 82.2396 27.5366C79.0861 26.1232 74.7358 24.9582 74.0203 27.6249C70.6689 40.1146 68.0622 50.3335 60.9871 52.2259Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5273 109.515C19.1676 109.691 23.9007 93.4936 25.6004 84.7156C25.8788 83.278 25.013 81.8871 23.6202 81.4352L14.6482 78.5243C13.6267 78.1929 12.5222 78.7233 12.2096 79.7507C8.63374 91.5018 9.65753 109.331 14.5273 109.515Z",
    fill: "#74A2D6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9003 0.498787C79.2297 3.82235 75.6933 16.9425 74.2265 25.8509C73.9894 27.2909 74.8566 28.6642 76.2379 29.1045L84.3246 31.6822C85.352 32.0097 86.4586 31.4596 86.7983 30.4281C91.137 17.2575 94.0307 -1.2644 88.9003 0.498787Z",
    fill: "#74A2D6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2178 48.2353C28.2178 46.0233 30.1116 45.2314 31.6106 45.2314C33.1096 45.2314 36.3605 44.2302 47.2174 44.7308C58.0742 45.2314 61.3251 44.2302 62.8241 44.2302C64.3231 44.2302 65.5383 46.0233 65.5383 48.2353V50.2379C65.5383 52.4498 64.5727 54.243 61.467 54.243C58.3613 54.243 51.7539 53.2054 45.521 53.2417C39.8175 53.2749 32.4311 54.243 30.9321 54.243C29.433 54.243 28.2178 52.4498 28.2178 50.2379V48.2353Z",
    fill: "#EF86B0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1217 67.8968C94.6666 70.1725 95.5768 73.3584 96.4871 74.2686M98.3076 70.6276L91.9358 72.3343",
    stroke: "#F7D06F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6321 6.97478C12.4687 8.98284 12.9791 14.8229 11.6448 13.4726M15.7695 10.5857L9.18742 10.1507",
    stroke: "#F7D06F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4347 128.193C12.9796 130.468 13.4347 133.654 13.4347 134.564M16.6206 130.923C13.8576 131.928 12.2771 132.229 9.33856 131.834C9.85802 132.571 10.2984 132.689 11.1591 132.744",
    stroke: "#F7D06F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5145 115.121L53.955 128.195C54.2888 129.464 53.3322 130.704 52.0209 130.704H42.1197C40.8223 130.704 39.6055 131.334 38.8556 132.392L35.4549 137.193C34.3798 138.711 31.9962 138.068 31.8308 136.215L30.378 119.944C30.1879 117.815 31.7044 115.913 33.8217 115.624L48.3101 113.649C49.3115 113.512 50.2573 114.144 50.5145 115.121Z",
    fill: "#74A2D6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.543 137.794L81.0259 137.018C82.3394 136.943 83.3668 138.134 83.0988 139.422L80.9717 149.65C80.7115 150.901 81.0646 152.201 81.9217 153.148L85.5818 157.193C86.8271 158.57 85.6887 160.753 83.8473 160.519L68.2075 158.538C66.1109 158.272 64.5826 156.421 64.7185 154.312L65.6621 139.662C65.727 138.654 66.5341 137.852 67.543 137.794Z",
    fill: "#74A2D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5704,
    cy: 43.7751,
    r: 2.27564,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.27564,
    cy: 67.4417,
    r: 2.27564,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.2705,
    cy: 144.052,
    r: 2.27564,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.8121,
    cy: 37.9319,
    r: 2.27564,
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5509 39.6346C47.521 39.4648 46.5485 40.1621 46.3787 41.192C46.2089 42.2219 46.9062 43.1945 47.9361 43.3643L48.5509 39.6346ZM54.635 42.2345C55.5437 41.7209 55.864 40.5679 55.3504 39.6592C54.8368 38.7505 53.6838 38.4302 52.7751 38.9438L54.635 42.2345ZM47.9361 43.3643C49.2038 43.5732 50.3223 43.6489 51.447 43.4595C52.5803 43.2686 53.5764 42.8329 54.635 42.2345L52.7751 38.9438C51.9152 39.4298 51.3515 39.6423 50.8192 39.732C50.2782 39.8231 49.6252 39.8117 48.5509 39.6346L47.9361 43.3643Z",
    fill: "#57455D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7435 86.102L22.3012 88.3776",
    stroke: "#57455D",
    strokeWidth: 3.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7117 89.2879H67.8143",
    stroke: "#57455D",
    strokeWidth: 3.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9745 76.9994L59.6219 76.0891",
    stroke: "#57455D",
    strokeWidth: 3.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9745 70.6276L59.1668 68.8071",
    stroke: "#57455D",
    strokeWidth: 3.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6411 23.2943L84.1987 25.57",
    stroke: "#57455D",
    strokeWidth: 3.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6346 143.448H81.0128",
    stroke: "#57455D",
    strokeWidth: 3.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2692 128.884C73.9871 128.267 76.874 127.728 81.0128 126.153",
    stroke: "#57455D",
    strokeWidth: 3.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0576 117.506L45.9679 127.063",
    stroke: "#57455D",
    strokeWidth: 3.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnstackExpertIcon);
export default __webpack_public_path__ + "static/media/unstack-expert-icon.15476d9ed1b0960c48f61b6374d44779.svg";
export { ForwardRef as ReactComponent };